<template>
    <div class="w-100">
        <v-img :src="src" class="w-100 mb-12 mb-lg-24"></v-img>
        <h5 class="tit--sm font-weight-medium" v-if="tit">
            {{tit}}
        </h5>
        <slot/>
    </div>
</template>

<script>

export default{
    props : {
        tit : {type :String, default : ""},
        src : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
</style>